import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { CallState } from "redmond";

import { ShopErrorModal } from "./component";
import {
  getExperiencesNoAvailability,
  getExperiencesShopCallState,
} from "../../reducer/selectors";
import { IStoreState } from "../../../../reducers/types";
import { fetchExperienceShop } from "../../../../api/v0/shop/fetchExperiencesShop";

const mapStateToProps = (state: IStoreState) => ({
  hasError: getExperiencesShopCallState(state) === CallState.Failed,
  noAvailability: getExperiencesNoAvailability(state),
});

const mapDispatchToProps = {
  fetchExperienceShop,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ShopErrorModalConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedShopErrorModal = withRouter(connector(ShopErrorModal));
